import styled from "styled-components";

import vars from "variables";

import icon from "assets/icon.png";

import addresses from "assets/Dashboard/addresses.svg";
import reflections from "assets/Dashboard/reflections.svg";
import reinvestments from "assets/Dashboard/reinvestments.svg";
import rewards from "assets/Dashboard/rewards.svg";
import welcome from "assets/Dashboard/welcome.png";

const Root = styled.main`
  #___gatsby & {
    margin-top: -4px;
  }

  & > div {
    width: calc(100% - 372px);
  }

  #dashboard-layout {
    position: relative;
  }

  .over {
    position: absolute;
    pointer-events: none;
  }

  .over.open {
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    pointer-events: auto;
    opacity: 0.65;
    background: black;
    z-index: 1;
  }

  ${vars.desktop.mediaQuery} {
    display: flex;

    & > div {
      padding: 37px;
      padding-left: 35px;
    }

    [data-row-count="2"] {
      width: calc(100% + 5px);
    }

    [data-row-count="3"] {
      width: calc(100% + 3px);
    }

    [data-row-count="4"] {
      width: calc(100% + 4px);
    }
  }

  ${vars.mobile.mediaQuery} {
    & > div {
      width: calc(100% - 30px);
      padding: 18px 15px;
    }
  }
`;

const Message = styled.div`
  font-size: 0.85rem;
  letter-spacing: 0.5px;

  h3 {
    width: calc(100% + 40px);
    padding: 0;
    text-align: left;
  }

  h3 i {
    display: inline-block;
    background: url(${icon});
    background-repeat: no-repeat;
    background-size: 100%;
  }

  p {
    margin: 12px 0;
  }

  ul {
    margin: 30px 0;
  }

  li {
    padding-left: 30px;
    background-repeat: no-repeat;
    background-position: left center;
  }

  li.addresses {
    background-image: url(${addresses});
  }

  li.reflections {
    background-image: url(${reflections});
  }

  li.reinvestments {
    background-image: url(${reinvestments});
  }

  li.rewards {
    background-image: url(${rewards});
    background-size: 20px;
  }

  .buttons strong {
    font-size: 0.8rem;
  }

  ${vars.desktop.mediaQuery} {
    div.wrapper {
      margin: -55px -70px -50px -13px;
      padding: 45px 450px 25px 0;
      background-image: url(${welcome});
      background-position: top right;
      background-repeat: no-repeat;
      background-size: auto 100%;
    }

    h3 {
      font-size: 1.75rem;
      font-weight: 800;
    }

    h3 i {
      width: 26px;
      height: 26px;
    }

    p {
      width: 375px;
      color: grey;
    }

    ul {
      margin-top: 10px;
    }

    .buttons {
      padding-bottom: 20px;
    }

    strong {
      margin: 0 18px;
      display: inline-block;
    }
  }

  ${vars.mobile.mediaQuery} {
    margin: 0 -12px;

    div.wrapper {
      margin: -34px -13px -5px -13px;
      padding: 45px 30px 25px 30px;
    }

    h3 {
      font-size: 1.2rem;
      font-weight: 700;
    }

    h3 i {
      width: 16px;
      height: 16px;
    }

    li {
      line-height: 2.25rem;
    }

    .buttons {
      text-align: center;
    }

    a.button {
      margin: 0 auto;
      margin-top: 10px;
      margin-bottom: 10px;
      display: block;
      text-align: center;
    }
  }
`;

export { Root, Message };
